"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var VueSlickgrid_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VueSlickgrid = exports.VueSlickgridBehaviorProps = exports.VueSlickgridDataExportProps = void 0;
require("./styles.scss");
const _ = __importStar(require("lodash"));
const lodash_1 = require("lodash");
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_context_1 = __importDefault(require("vue-context"));
const VueSlickgrid_html_1 = __importDefault(require("./VueSlickgrid.html"));
const VueSlickgridColumnSelector_1 = require("./VueSlickgridColumnSelector");
const plugins = __importStar(require("./plugins"));
const LocalData_1 = require("./LocalData");
const cols = __importStar(require("./columns"));
const helpers_1 = require("./helpers");
const messages = __importStar(require("./translations"));
const slickgrid_1 = require("slickgrid");
const formatters_1 = require("./formatters");
const DEFAULT_LOCALE = 'en';
function isSlickColumnsProvider(value) {
    return _.isFunction(value);
}
let VueSlickgridDataExportProps = class VueSlickgridDataExportProps extends vue_1.default {
    exportToCsv;
    exportToCsvFilename;
    exportToCsvQuotechar;
    exportToCsvDelimiter;
    localeCode;
    get dataExportPropValues() {
        return {
            exportToCsv: this.exportToCsv,
            exportToCsvFilename: this.exportToCsvFilename,
            exportToCsvQuotechar: this.exportToCsvQuotechar,
            exportToCsvDelimiter: this.exportToCsvDelimiter,
            localeCode: this.localeCode
        };
    }
};
exports.VueSlickgridDataExportProps = VueSlickgridDataExportProps;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgridDataExportProps.prototype, "exportToCsv", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: String }),
    __metadata("design:type", String)
], VueSlickgridDataExportProps.prototype, "exportToCsvFilename", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '"', type: String }),
    __metadata("design:type", String)
], VueSlickgridDataExportProps.prototype, "exportToCsvQuotechar", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: ';', type: String }),
    __metadata("design:type", String)
], VueSlickgridDataExportProps.prototype, "exportToCsvDelimiter", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'en-EN', type: String }),
    __metadata("design:type", String)
], VueSlickgridDataExportProps.prototype, "localeCode", void 0);
exports.VueSlickgridDataExportProps = VueSlickgridDataExportProps = __decorate([
    vue_property_decorator_1.Component
], VueSlickgridDataExportProps);
let VueSlickgridBehaviorProps = class VueSlickgridBehaviorProps extends vue_1.default {
    editable;
    autoEdit;
    autoHeight;
    cellNavigation;
    noColumnReorder;
    noTextSelection;
    rowHeader;
    checkboxRowSelection;
    rowClass;
    get behaviorPropValues() {
        return {
            editable: this.editable,
            autoEdit: this.autoEdit,
            autoHeight: this.autoHeight,
            cellNavigation: this.cellNavigation,
            noColumnReorder: this.noColumnReorder,
            noTextSelection: this.noTextSelection,
            rowHeader: this.rowHeader,
            checkboxRowSelection: this.checkboxRowSelection,
            rowClass: this.rowClass
        };
    }
};
exports.VueSlickgridBehaviorProps = VueSlickgridBehaviorProps;
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgridBehaviorProps.prototype, "editable", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgridBehaviorProps.prototype, "autoEdit", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgridBehaviorProps.prototype, "autoHeight", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgridBehaviorProps.prototype, "cellNavigation", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgridBehaviorProps.prototype, "noColumnReorder", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgridBehaviorProps.prototype, "noTextSelection", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgridBehaviorProps.prototype, "rowHeader", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgridBehaviorProps.prototype, "checkboxRowSelection", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", Object)
], VueSlickgridBehaviorProps.prototype, "rowClass", void 0);
exports.VueSlickgridBehaviorProps = VueSlickgridBehaviorProps = __decorate([
    vue_property_decorator_1.Component
], VueSlickgridBehaviorProps);
let VueSlickgrid = class VueSlickgrid extends (0, vue_property_decorator_1.Mixins)(VueSlickgridDataExportProps, VueSlickgridBehaviorProps) {
    static { VueSlickgrid_1 = this; }
    pluginName = 'VueSlickgrid';
    $refs;
    static _defaults;
    defaults;
    onWindowResize;
    static Instances = [];
    static setDefaults(defaults) {
        if (!VueSlickgrid_1._defaults) {
            VueSlickgrid_1._defaults = [];
        }
        VueSlickgrid_1._defaults.push(defaults);
    }
    ALL_FORMATTERS;
    _rowClassResolver;
    _lastViewport;
    _lastScrollTop;
    grid;
    gridData;
    gridColumns;
    gridOptions;
    gridPlugins;
    messages;
    eventHandler;
    requestsCompleted;
    status;
    totalRowCount;
    visibleRowCount;
    get isFilteredView() {
        return (this.totalRowCount != null &&
            this.visibleRowCount != null &&
            this.totalRowCount > this.visibleRowCount);
    }
    translations;
    lc;
    get msg_records_title() {
        const template = this.isFilteredView
            ? this.messages.records_filtered_text
            : this.messages.records_text;
        return _.template(template)(this);
    }
    get msg_records_text() {
        return this.isFilteredView
            ? `${this.visibleRowCount} / ${this.totalRowCount}`
            : this.visibleRowCount;
    }
    name;
    columns;
    columnDefaults;
    preferredColumnOrder;
    items;
    get showHeader() {
        return this.noHeader === false;
    }
    noHeader;
    headerTitle;
    headerShowRowCount;
    headerShowReloadButton;
    headerShowDataExportButton;
    headerShowColumnSelectorButton;
    footerTotals;
    headerDropdownFilter;
    headerRowFilter;
    editCommandHandler;
    onRowClassChanged(newValue) {
        this.setRowClassResolver(newValue);
    }
    noTooltips;
    tooltipsEnableForCells;
    tooltipsEnableForHeaderCells;
    tooltipsMaxToolTipLength;
    statePersist;
    stateKey;
    contextMenu;
    resizeTrigger;
    options;
    grouping;
    onResizeTriggerChanged(oldval, newval) {
        if (oldval != newval) {
            this.$nextTick(() => this.resizeCanvas('resizeTrigger'));
        }
    }
    onItemsChanged(newValue) {
        this.gridData.replaceDataSource(newValue);
    }
    get className() {
        return {
            'auto-height': this.autoHeight
        };
    }
    get loading() {
        return this.status === 'loading';
    }
    get exporting() {
        return this.status === 'exporting';
    }
    get busy() {
        return this.status != null;
    }
    activated() {
        console.log(`slickgrid activated [${this.name}] scrollTop: ${this._lastScrollTop}`);
        this.resizeCanvas('activated');
        const scrollTop = this._lastScrollTop;
        if (scrollTop) {
            this.resetScrollPosition(scrollTop);
        }
        if (scrollTop) {
        }
    }
    deactivated() {
        this.saveScrollPosition();
    }
    created() {
        VueSlickgrid_1.Instances.push(this);
        this.onWindowResize = _.debounce(() => this.grid && this.resizeCanvas('onWindowResize'), 250);
        const onReload = (args) => {
            if (_.isArray(args.grid) && args.grid.indexOf(this.name)) {
                return this.reload();
            }
            if (_.isString(args.grid) &&
                (args.grid === 'all' || args.grid === this.name)) {
                return this.reload();
            }
        };
        const onResize = (args) => {
            if (args && args.resetScrollPosition) {
            }
            this.$nextTick(() => this.resizeCanvas('onResize'));
        };
        const onSaveScrollPosition = () => this.saveScrollPosition();
        this.$root.$on('slickgrid:reload', onReload);
        this.$root.$on('slickgrid:resize', onResize);
        this.$once('hook:beforeDestroy', () => {
            this.$root.$off('slickgrid:reload', onReload);
            this.$root.$off('slickgrid:resize', onResize);
        });
    }
    getDefaults() {
        if (!VueSlickgrid_1._defaults) {
            return {};
        }
        return _.reduce(VueSlickgrid_1._defaults, (m, v) => _.extend(m, v(this)), {});
    }
    getLocaleCode(defaults) {
        return this.lc || (defaults && defaults.lc) || DEFAULT_LOCALE;
    }
    data() {
        const defaults = this.getDefaults();
        this.setRowClassResolver(this.rowClass || defaults['rowClass']);
        return {
            grid: null,
            gridData: null,
            gridColumns: null,
            gridPlugins: null,
            gridOptions: null,
            status: null,
            totalRowCount: null,
            visibleRowCount: null,
            requestsCompleted: 0,
            eventHandler: new slickgrid_1.SlickEventHandler(),
            messages: this.getMessages(this.getLocaleCode(defaults)),
            defaults
        };
    }
    mounted() {
        this.ALL_FORMATTERS = (0, formatters_1.getAllFormatters)();
        this.createGrid();
        window.addEventListener('resize', this.onWindowResize);
    }
    destroyed() {
        _.remove(VueSlickgrid_1.Instances, p => p === this);
        this.eventHandler.unsubscribeAll();
        window.removeEventListener('resize', this.onWindowResize);
        if (this.grid) {
            this.grid.destroy();
        }
    }
    createGrid() {
        this.gridData = new LocalData_1.LocalData({
            items: this.items,
            rowAdapter: this.dataRowAdapter,
            groupBy: this.grouping != null
        });
        this.gridColumns = this.getColumns();
        this.gridPlugins = this.getPlugins(this.gridColumns, this.gridData);
        this.gridOptions = this.getOptions(this.gridPlugins);
        this.grid = new slickgrid_1.SlickGrid(this.$refs.slickgrid, this.gridData.data, this.gridColumns.slice(), this.gridOptions);
        _.set(this.grid, 'ALL_FORMATTERS', this.ALL_FORMATTERS);
        _.each(this.gridPlugins, p => this.grid.registerPlugin(p));
        this.addEventListeners(this.gridPlugins);
        this.grid.init();
        this.afterInit();
        this.grid.invalidate();
        this.resizeCanvas('createGrid');
        this.grid.onViewportChanged.notify({ grid: this.grid });
        (0, helpers_1.fixColumnHeaderClickedAfterResize)(this.grid);
        this.onWindowResize();
        this.addEventListeners(this.grid);
        if (this.grouping) {
            this.gridData.groupBy(this.grouping);
            this.grid.invalidate();
            this.resizeCanvas('createGrid|grouping');
        }
        console.log('createGrid completed', this.grid);
    }
    getSelectedItems() {
        return _.filter(this.gridData.getItems(false), { $selected: true });
    }
    getVisibleItems() {
        return this.gridData.getItems(true);
    }
    resizeCanvas(source) {
        if (this.grid) {
            console.log(`resizeCanvas [${this.name}] ${source || '-'}`);
            this.grid.resizeCanvas();
        }
    }
    resetScrollPosition(scrollTop) {
        if (scrollTop || this._lastScrollTop) {
            this.$nextTick(() => {
                const lastTop = scrollTop || this._lastScrollTop;
                console.log(`resetScrollPosition [${this.name}] ${lastTop}`);
                this.grid.scrollTo(lastTop);
            });
        }
    }
    saveScrollPosition() {
        this._lastScrollTop = this.grid.getViewport().top;
        console.log(`saveScrollPosition [${this.name}] ${this._lastScrollTop}`);
    }
    async reload() {
        await this.gridData.reload();
    }
    async exportData(format = 'csv') {
        const target = _.find(this.gridPlugins, p => p instanceof plugins.DataExport);
        if (target) {
            const localeCode = this.getLocaleCode(this.defaults);
            const lc = `${localeCode}-${localeCode.toUpperCase()}`;
            return target.exportData(format, lc);
        }
    }
    getColumns() {
        const defaults = this.columnDefaults;
        let result = [];
        if (this.rowHeader) {
            result.push(cols.configure({ type: 'rowHeader' }, defaults));
        }
        if (this.checkboxRowSelection) {
            result.push(new plugins.CheckboxColumn({
                headerSelect: true,
                rowSelector: true,
                toolTip: this.messages.checkboxRowSelectionHeaderToolTip
            }));
        }
        const columns = isSlickColumnsProvider(this.columns)
            ? this.columns(this)
            : this.columns;
        result = result.concat((0, lodash_1.chain)(columns)
            .filter(c => _.get(c, 'if', true))
            .map(c => cols.configure(c, this.columnDefaults))
            .value());
        let dupes = (0, lodash_1.chain)(result)
            .groupBy(p => p.id)
            .filter((group, key) => group.length > 1)
            .map(p => _.first(p).id)
            .uniq()
            .value();
        if (dupes.length) {
            throw new Error(`duplicate column ids found: ${dupes}`);
        }
        if (this.preferredColumnOrder) {
            const prefs = this.preferredColumnOrder, columnCount = result.length;
            return _.sortBy(result, col => {
                const i = _.indexOf(result, col);
                if (col.frozen) {
                    return i;
                }
                let idx = _.indexOf(prefs, col.id);
                if (idx > -1) {
                    return columnCount + idx;
                }
                return columnCount * 2 + i;
            });
        }
        return result;
    }
    getPlugins(columns, data) {
        if (this.gridPlugins) {
            return this.gridPlugins;
        }
        const result = [];
        _.each(columns, col => {
            if ((0, helpers_1.isPluginObject)(col)) {
                result.push(col);
            }
        });
        result.push(data);
        if (this.headerRowFilter) {
            result.push(new plugins.HeaderRowFilters());
        }
        if (this.noTooltips !== true) {
            result.push(new slickgrid_1.SlickAutoTooltips({
                enableForCells: this.tooltipsEnableForCells,
                enableForHeaderCells: this.tooltipsEnableForHeaderCells,
                maxToolTipLength: this.tooltipsMaxToolTipLength
            }));
        }
        if (this.exportToCsv !== false) {
            result.push(new plugins.DataExport({
                filename: this.exportToCsvFilename,
                quoteChar: this.exportToCsvQuotechar,
                delimiter: this.exportToCsvDelimiter,
                getDataItems: this.gridData.getItems.bind(this.gridData),
                localeCode: this.localeCode
            }));
        }
        const stateKey = this.stateKey || this.defaults.stateKey;
        if (this.statePersist && stateKey) {
            result.push(new plugins.State({
                key: stateKey,
                defaultColumns: columns
            }));
        }
        result.push(new plugins.AutosizeColumn());
        if (this.footerTotals) {
            result.push(new plugins.RowTotalsPlugin());
        }
        return result;
    }
    getOptions(plugins) {
        let result = {
            editable: this.editable,
            autoEdit: this.autoEdit,
            autoHeight: this.autoHeight,
            editCommandHandler: this.editCommandHandler,
            enableCellNavigation: true,
            explicitInitialization: true,
            enableColumnReorder: !this.noColumnReorder,
            enableTextSelectionOnCells: true
        };
        if (this.footerTotals) {
            result.createFooterRow = true;
            result.showFooterRow = true;
            result.footerRowHeight = 25;
        }
        _.each(plugins, p => {
            let fn = p['getOptions'];
            if (_.isFunction(fn)) {
                _.extend(result, fn());
            }
        });
        if (this.options) {
            _.extend(result, this.options);
        }
        return result;
    }
    addEventListeners(plugins) {
        if (_.isArray(plugins)) {
            _.each(plugins, p => {
                _.each(DefaultEventHandlers, (handler, name) => {
                    let member = p[name];
                    if (_.isObject(member) && (0, helpers_1.isSlickEvent)(member)) {
                        this.eventHandler.subscribe(member, handler.bind(this));
                    }
                });
            });
            return;
        }
        if (_.isObject(plugins)) {
            _.each(DefaultEventHandlers, (handler, name) => {
                let member = plugins[name];
                if (_.isObject(member) && (0, helpers_1.isSlickEvent)(member)) {
                    this.eventHandler.subscribe(member, handler.bind(this));
                }
            });
        }
    }
    afterInit() {
        if (this.statePersist) {
            let state = this.gridPlugins.find(p => p instanceof plugins.State);
            if (state) {
                state.restore();
            }
        }
    }
    initColumns() {
        let state = this.gridPlugins.find(p => p instanceof plugins.State);
        if (state && state.isEmpty) {
            let autosize = this.gridPlugins.find(p => p instanceof plugins.AutosizeColumn);
            if (autosize) {
                autosize.resizeAllColumns();
            }
        }
    }
    onLanguageCodeChange(value) {
        this.messages = this.getMessages(value);
    }
    getMessages(lc) {
        const result = {};
        if (this.translations && this.translations[lc]) {
            _.extend(result, this.translations);
        }
        else if (messages[lc]) {
            _.extend(result, messages[lc]);
        }
        if (_.isEmpty(result)) {
            console.warn(`Translations are missing for LC="${lc}"`);
        }
        _.each(messages.en, (v, k) => {
            if (result[k] == null) {
                result[k] = v;
            }
        });
        return result;
    }
    onContextMenu(event) {
        if (this.contextMenu && this.$refs.contextMenu) {
            const cell = this.grid.getCellFromEvent(event);
            if (cell) {
                this.grid.setActiveCell(cell.row, cell.cell);
                this.$refs.contextMenu.open(event);
                event.preventDefault();
                return false;
            }
            this.$refs.contextMenu.close();
        }
    }
    onContextMenuClick(item) {
        const cell = this.grid.getActiveCell();
        if (!cell) {
            console.warn('cannot process context menu click: the grid has no active cell.');
            return;
        }
        const command = item.command;
        if (!_.isString(command)) {
            console.warn(`cannot process context menu click: command is not typeof string - ${command}`);
            return;
        }
        const args = {
            command,
            row: cell.row,
            data: this.grid.getDataItem(cell.row)
        };
        this.$emit('contextmenu', args);
        if (command) {
            this.$emit(`contextmenu:${command}`, args);
        }
    }
    dataRowAdapter(data) {
        const itemMetadata = {};
        if (this.isSelected(data['id'])) {
            data['$selected'] = true;
        }
        if (this._rowClassResolver) {
            const rowCssClass = this._rowClassResolver(data);
            data['$slickRowCssClass'] = rowCssClass;
            itemMetadata['cssClasses'] = (0, helpers_1.getCssClasses)(rowCssClass);
        }
        data['$__itemMetadata__'] = itemMetadata || null;
        return data;
    }
    isSelected(id) {
        return (this['$$selectedIds'] &&
            _.indexOf(this['$$selectedIds'], id) > -1);
    }
    setRowClassResolver(value) {
        if (_.isFunction(value)) {
            this._rowClassResolver = value;
        }
        if (value == null) {
            this._rowClassResolver = null;
        }
    }
};
exports.VueSlickgrid = VueSlickgrid;
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], VueSlickgrid.prototype, "translations", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], VueSlickgrid.prototype, "lc", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", String)
], VueSlickgrid.prototype, "name", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], VueSlickgrid.prototype, "columns", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], VueSlickgrid.prototype, "columnDefaults", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Array)
], VueSlickgrid.prototype, "preferredColumnOrder", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], VueSlickgrid.prototype, "items", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgrid.prototype, "noHeader", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], VueSlickgrid.prototype, "headerTitle", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgrid.prototype, "headerShowRowCount", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgrid.prototype, "headerShowReloadButton", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgrid.prototype, "headerShowDataExportButton", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgrid.prototype, "headerShowColumnSelectorButton", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgrid.prototype, "footerTotals", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false }),
    __metadata("design:type", Object)
], VueSlickgrid.prototype, "headerDropdownFilter", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgrid.prototype, "headerRowFilter", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", Function)
], VueSlickgrid.prototype, "editCommandHandler", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('rowClass'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Function]),
    __metadata("design:returntype", void 0)
], VueSlickgrid.prototype, "onRowClassChanged", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: false, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgrid.prototype, "noTooltips", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgrid.prototype, "tooltipsEnableForCells", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgrid.prototype, "tooltipsEnableForHeaderCells", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null, type: Number }),
    __metadata("design:type", Number)
], VueSlickgrid.prototype, "tooltipsMaxToolTipLength", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: true, type: Boolean }),
    __metadata("design:type", Boolean)
], VueSlickgrid.prototype, "statePersist", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], VueSlickgrid.prototype, "stateKey", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], VueSlickgrid.prototype, "contextMenu", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], VueSlickgrid.prototype, "resizeTrigger", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], VueSlickgrid.prototype, "options", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", Object)
], VueSlickgrid.prototype, "grouping", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('resizeTrigger'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], VueSlickgrid.prototype, "onResizeTriggerChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('items'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], VueSlickgrid.prototype, "onItemsChanged", null);
__decorate([
    (0, vue_property_decorator_1.Watch)('lc'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], VueSlickgrid.prototype, "onLanguageCodeChange", null);
exports.VueSlickgrid = VueSlickgrid = VueSlickgrid_1 = __decorate([
    (0, vue_property_decorator_1.Component)({
        template: VueSlickgrid_html_1.default,
        components: {
            VueContext: vue_context_1.default,
            VueSlickgridColumnSelector: VueSlickgridColumnSelector_1.VueSlickgridColumnSelector
        }
    })
], VueSlickgrid);
const DefaultEventHandlers = {
    onCommand(e, args) {
        this.$emit('command', args);
        this.$emit(`command:${args.column.field || args.column.name}`, args);
    },
    onDataExporting(e, args) {
        this.status = args.status ? 'exporting' : null;
    },
    onDataLoading() {
        this.status = 'loading';
        this['$$selectedIds'] = _.map(this.getSelectedItems(), p => p.id);
    },
    onDataLoaded(e, args) {
        this.status = null;
        this.requestsCompleted += 1;
        if (this.requestsCompleted === 1) {
            this.initColumns();
        }
        this.$emit('dataLoaded', { items: this.getVisibleItems() });
    },
    onDataLoadFailed(e, args) {
        this.status = null;
        this.requestsCompleted += 1;
        const eventArgs = { type: 'dataload', error: args.error };
        this.$emit('error', eventArgs);
        if (_.isFunction(this.defaults.errorHandler)) {
            this.defaults.errorHandler(eventArgs);
        }
    },
    onRowCountChanged(e, args) {
        this.totalRowCount = args.total;
        this.visibleRowCount = args.visible;
    },
    onRowsChanged(e, args) {
        this.$emit('rowsChanged', args);
    },
    onColumnFilterChange(e, args) {
        this.gridData.filter(args.filters);
    },
    onSelectedRowsChanged(e, args) {
        this.$emit('selectedRowsChanged', { sender: this, ...args });
    },
    onScroll(e, args) {
    }
};
//# sourceMappingURL=VueSlickgrid.js.map